<script setup lang="ts">
  import { storeToRefs } from 'pinia';

  import { useI18 } from '@/plugins';
  import { useLocaleStore } from '@/stores/locale.store';

  const langs = [
    {
      value: 'ar',
      name: 'العربية',
    },
    {
      value: 'en',
      name: 'English',
    },
  ];
  const localeStore = useLocaleStore();
  const { locale } = storeToRefs(localeStore);
  const i18 = useI18();
  const { t } = i18;
  const changeLocale = (languageCode: string) => {
    localeStore.changeLocale(languageCode, i18.i18next);
  };
</script>

<template>
  <v-menu>
    <template #activator="{ props, isActive }">
      <div class="d-flex ga-2 align-center text-capitalize" v-bind="props">
        {{ locale }}
        <v-icon :icon="isActive ? 'mdi-menu-up' : 'mdi-menu-down'"></v-icon>
      </div>
    </template>
    <v-list>
      <v-list-item
        v-for="lang in langs"
        :key="lang.value"
        :value="lang.value"
        @click="changeLocale(lang.value)"
      >
        <v-list-item-title>{{ lang.name }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
